
import React from "react";
import { UserBadge, BadgeType } from "./UserBadge";

interface Badge {
  id: string;
  type: BadgeType;
  label: string;
  description: string;
}

interface UserBadgesProps {
  badges: Badge[];
}

export const UserBadges: React.FC<UserBadgesProps> = ({ badges }) => {
  if (badges.length === 0) {
    return null;
  }
  
  return (
    <div className="flex flex-wrap gap-2">
      {badges.map(badge => (
        <UserBadge 
          key={badge.id}
          type={badge.type}
          label={badge.label}
          description={badge.description}
        />
      ))}
    </div>
  );
};

export default UserBadges;
